// Single ephemeral toast. Polite live region so screen readers announce it
// without interrupting the user.

import { useEffect } from 'react';
import { C } from '@/styles/tokens';

export interface ToastMessage {
  id: number;
  text: string;
  tone?: 'default' | 'success' | 'warning';
}

interface ToastProps {
  toast: ToastMessage | null;
  onDismiss: () => void;
}

export function Toast({ toast, onDismiss }: ToastProps) {
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(onDismiss, 2400);
    return () => window.clearTimeout(t);
  }, [toast, onDismiss]);

  if (!toast) return null;

  const palette =
    toast.tone === 'success'
      ? { bg: C.jade, fg: 'white' }
      : toast.tone === 'warning'
        ? { bg: C.gold, fg: 'white' }
        : { bg: C.ink, fg: 'white' };

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed left-1/2 bottom-6 -translate-x-1/2 z-50 px-4 py-2 rounded-full ff-body text-sm shadow-xl anim-scale-in"
      style={{ background: palette.bg, color: palette.fg }}
    >
      {toast.text}
    </div>
  );
}
